import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6c02b1cf")
const _hoisted_1 = { class: "button" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("mdi-plus-box-outline")
const _hoisted_3 = ["innerHTML"]
_popScopeId()

import { withDefaults, ref, onMounted } from 'vue'
import { AxiosInstance } from 'axios'
import bus from '@/lib/eventBus'
import EventNames from '@/lib/enums/eventNames'

import createHoppermationAPIClient from '@/clients/hoppermation'
import Action from '../../Dialog/enums/DialogAction'
import TheDialog from '../../Dialog/TheDialog.vue'
import { IAutomation } from '@/interfaces/hoppermation'

interface IProps {
  automation?: IAutomation
  submit?: () => void
}


export default /*#__PURE__*/_defineComponent({
  props: {
    automation: { type: null, required: false, default: () => ({} as IAutomation) },
    submit: { type: Function, required: false, default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { automation: IAutomation, submit: () => void }


const hoppermationApiClient = ref({} as AxiosInstance)
const action = Action.CONFIRM

onMounted(async () => {
  hoppermationApiClient.value = await createHoppermationAPIClient()
})

const makeNewVersion = async (): Promise<boolean> => {
  try {
    await hoppermationApiClient.value.post(`/automations/${props.automation.id}/new-version`)
    bus.$emit(EventNames.SHOW_SNACKBAR, { color: 'success', text: 'snackbar.automation.newVersion.success' })
    props.submit()
    return true
  } catch (error) {
    bus.$emit(EventNames.SHOW_SNACKBAR, { color: 'error', text: 'snackbar.automation.newVersion.error' })
    return false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(TheDialog, {
    action: _unref(action),
    title: _ctx.$t('dialog.newVersion.title'),
    submit: makeNewVersion,
    imageSrc: "https://assets8.lottiefiles.com/packages/lf20_u25cckyh.json"
  }, {
    activator: _withCtx(({ props }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_icon, _mergeProps(props, {
          size: "small",
          class: "mr-5"
        }), {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 2
        }, 1040)
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("p", {
        class: "text-subtitle",
        innerHTML: _ctx.$t('dialog.newVersion.desc', { automationName: props.automation.name })
      }, null, 8, _hoisted_3)
    ]),
    _: 1
  }, 8, ["action", "title"]))
}
}

})